module.exports = __webpack_public_path__ + "img/home_top.eae3eae2.jpg";